var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c(_setup.Pill,{attrs:{"color":_setup.data[_vm.value].color}},[_c(_setup.Typo,{attrs:{"variant":"body-l-400"}},[_vm._v("\n        "+_vm._s(_setup.data[_vm.value].text)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }